import React, { Component } from 'react';
import { FILE_URL } from './Constant';

export default class DailyLife extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            images: props.images,
            static_text: props.static_text
        }
    }

    _kitchenIndSlider = () => {
        let indexing = -1;
        if (this.props.images.other != null && Object.keys(this.props.images.other).length > 0) {
            return (
                <ol className="carousel-indicators">
                    {
                        this.props.images.other.map((item, key) => {
                            if (item.tag == 'Kitchen') {
                                indexing = indexing + 1;
                                return (
                                    <React.Fragment>
                                        <li data-target="#main-carousel" data-slide-to={indexing} className={indexing == 0 ? "active" : ""}></li>
                                    </React.Fragment>
                                )

                            }

                        })

                    }
                </ol>
            )
        }

    }

    _kitchenSlider = () => {
        let indexing = -1;
        if (this.props.images.other != null && Object.keys(this.props.images.other).length > 0) {
            return (
                <div className="carousel-inner">
                    {
                        this.props.images.other.map((item, key) => {
                            if (item.tag == 'Kitchen') {
                                indexing = indexing + 1;
                                return (
                                    <div className={indexing == 0 ? "carousel-item active" : "carousel-item"}>
                                        <img src={FILE_URL + 'villas/' + item.image} className="img-fluid w-100 d-block" alt={item.image} />
                                    </div>
                                )

                            }

                        })

                    }
                </div>
            )
        }
    }

    _convList = () => {
        if (this.props.data != null) {
            if (this.props.data.convenience_store != null && this.props.data.convenience_store.length > 0) {
                return (
                    this.props.data.convenience_store.map((item, index) => {
                        if(item != ''){
                                return (
                                    <li><a href="javascript:void(0)" key={"cs-" + index} > {item}</a></li>
                                )
                        }
                    })
                )
            }
        }


    }

    _shopList = () => {
        //console.log(this.props.data.shops);
        if (this.props.data != null) {
            if (this.props.data.shops != null && this.props.data.shops.length > 0) {
                return (
                    this.props.data.shops.map((item, index) => {
                        if(item != ''){
                                return (
                                    <li><a href="javascript:void(0)" key={"shops-" + index} > {item}</a></li>
                                )
                        }
                    })
                )
            }
        }

    }

    _marketList = () => {
        if (this.props.data != null) {
            if (this.props.data.supermarket != null && this.props.data.supermarket.length > 0) {
                return (
                    this.props.data.supermarket.map((item, index) => {
                        if(item != ''){
                            return (
                                <li><a href="javascript:void(0)" key={"supermarket-" + index} > {item}</a></li>
                            )
                        }
                    })
                )
            }
        }
    }

    _restList = () => {

        if (this.props.data != null) {
            if (this.props.data.restraunts != null && this.props.data.restraunts.length > 0) {
                return (
                    this.props.data.restraunts.map((item, index) => {
                        if(item != ''){
                            return (
                                <li><a href="javascript:void(0)" key={"supermarket-" + index} > {item}</a></li>
                            )
                        }
                    })
                )
            }
        }
    }

    render() {
        return (
            <div id="daily-life">
                <div className="row">
                    <div className="col-md-12">
                        <h2>{this.props.static_text.daily_life_text}</h2>
                        <div className="row">
                            <div className="col-md-4">
                                <h6>{this.props.static_text.kitchen_text}</h6>
                                <p>{this.props.data != null?this.props.data.kitchen_text:''}</p>

                            </div>
                            <div className="col-md-8">
                                <div className="carousel slide" id="main-carousel" data-ride="carousel">
                                    {this._kitchenIndSlider()}
                                    {this._kitchenSlider()}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12" id="convenience-stores">
                                <h6>{this.props.data != null && this.props.data.convenience_store != null && this.props.data.convenience_store.length > 0 ? this.props.static_text.convenience_store_text :''}</h6>
                                <ul className="blue-btn">
                                    {this._convList()}
                                </ul>
                            </div>
                            <div className="col-md-12" id="shops">
                                <h6>{this.props.data != null && this.props.data.shops != null && this.props.data.shops.length > 0  && this.props.data.shops[0] !=''?this.props.static_text.shops_text:''}</h6>
                                <ul className="red-btn">
                                    {this._shopList()}
                                </ul>
                            </div>
                            <div className="col-md-12" id="supermarkets">
                                <h6>{this.props.data != null && this.props.data.supermarket != null && this.props.data.supermarket.length > 0 && this.props.data.supermarket[0] !=''?this.props.static_text.supermarket_text :''}</h6>
                                <ul className="blue-btn">
                                    {this._marketList()}
                                </ul>
                            </div>
                            
                            <div className="col-md-12" id="restaurants">
                                <h6>{this.props.data != null && this.props.data.restraunts != null && this.props.data.restraunts.length > 0 && this.props.data.restraunts[0] !=''? this.props.static_text.restaurant_text:''}</h6>
                                <ul className="red-btn">
                                    {this._restList()}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
